export default "__VITE_ASSET__D6avTt50__"